import {
  IAdminMedicationInquiryDetailsDto,
  IAdminMedicationInquiryDetailsEntry,
} from '@interfaces/adminMedications';

import {
  IAdminSupplementInquiryDetailsDto,
  IAdminSupplementInquiryDetailsEntry,
} from './adminSupplements';
import { IFetchListRequestPayload, IFetchListRequestProps, IIdentity, ITableData } from './common';

export enum TAdminInquiriesPageTab {
  Pending,
  Sent,
}

export interface IAdminSearchInquiriesProps extends IFetchListRequestProps {
  isPending: boolean;
}

export interface IAdminSearchInquiriesPayload {
  isPending: boolean;
  pagedResultsRequest: IFetchListRequestPayload;
}

export interface IAdminInquiryDetailsDto extends IIdentity {
  adminMedicationInquiryDetailsDto: IAdminMedicationInquiryDetailsDto[];
  adminSupplementInquiryDetailsDto: IAdminSupplementInquiryDetailsDto[];
  inquiryStatusId: number | null;
  organizationId: number | null;
  programCodeId: number | null;
  submittedOn: string | null;
  timeElapsed: string | null;
}

export interface IAdminInquiryDetails extends IAdminInquiryDetailsDto {
  inquiryItems: TAdminInquiryEntry[];
  isSupplementary: boolean;
}

export type IAdminInquiriesTableData = ITableData<IAdminInquiryDetails>;

export type TAdminInquiryEntry =
  | IAdminMedicationInquiryDetailsEntry
  | IAdminSupplementInquiryDetailsEntry;
